import React, { useMemo } from 'react'
import moment from 'moment'
import { Box } from 'transfix-ui/core'

interface ILaneAlertPickupAvailability {
  pickupAvailability: string[]
  pickupStartDate?: string | null
  pickupEndDate?: string | null
}

const LaneAlertPickupAvailability = React.memo<ILaneAlertPickupAvailability>(
  ({ pickupAvailability, pickupEndDate, pickupStartDate }) => {
    // Creating comma separated string of available pickup days.
    // Defaulting to "Pickup any day" if all days are selected
    const availability = useMemo(() => {
      return pickupAvailability.length === 0 || pickupAvailability.length >= 7
        ? 'Pickup any day'
        : pickupAvailability.map(day => day.substring(0, 3)).join(', ')
    }, [pickupAvailability])

    // Formatting Start & End Date
    const formattedStartDate = moment(pickupStartDate).format('MM/DD/yyyy')
    const formattedEndDate = moment(pickupEndDate).format('MM/DD/yyyy')

    return (
      <>
        <Box>{availability}</Box>
        {pickupStartDate && pickupEndDate && (
          <p className='text-secondary text-small pt1'>
            {formattedStartDate}&nbsp;to&nbsp;{formattedEndDate}
          </p>
        )}
      </>
    )
  }
)

export default LaneAlertPickupAvailability
